import React from 'react';

import {Atom, withSystem, Types} from '@packages/systems/wfdl';
import {emptyObject} from '@packages/utilities/fp/utils';
import {USYS_DOM_CLASS_NAMES} from '@packages/systems/users/constants';
import {
  UsysUtilityPageConstraint,
  setDisplayBlock,
  extraAtomFields,
} from './utils';

import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {defaultIntegratedTypes} from '@packages/utilities/integrated-types';
import {EvaluatedNodeData, getChildren} from '@packages/utilities/data-utils';

const UserFormSuccessState = Atom.createRender(
  ({attributes, classes, generateAttributes, context, data, renderChild}) => {
    const successClasses = classes.push(USYS_DOM_CLASS_NAMES.formSuccess);
    const props = generateAttributes(attributes, successClasses);

    const finalProps =
      context.get('formState') === 'success'
        ? {
            ...props,
            style: setDisplayBlock(props.style || emptyObject),
          }
        : props;

    return (
      <div {...finalProps}>
        {getChildren(data).map((child: EvaluatedNodeData) =>
          renderChild(child)
        )}
      </div>
    );
  }
);

const config = Atom.create({
  displayName: 'Success State',
  showEmpty: true,
  constraints: {
    pinToParent: true,
    page: [UsysUtilityPageConstraint],
  },
  lockedStyles: {
    display: {
      when: true,
      message:
        "The display setting can't be changed for a form's success message.",
    },
  },
  render: UserFormSuccessState,
  dataType: withSystem(
    {private: true},
    TRecord(
      Types.deepMergeTypes(defaultIntegratedTypes, {
        attr: TRecord({
          // tabIndex is required to focus a normally non-iterative element
          tabIndex: withSystem({defaultValue: '-1'}, TText),
        }),
        children: TListOfElement,
      }),
      extraAtomFields
    )
  ),
  style: {
    base: {
      main: {
        noPseudo: {
          display: 'none',
        },
      },
    },
  },
});

export default config;
